import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SHADES = [
  { name: "Mocha", hex: "#8A6247", note: "The signature. Warm, grounded, unmistakable." },
  { name: "Taupe", hex: "#B8AFA6", note: "The quiet one. Softens everything it touches." },
  { name: "Beige", hex: "#E5DFD5", note: "The light touch. Barely there, completely present." },
  { name: "Clay", hex: "#A96A44", note: "The new one. Terracotta warmth, fired and grounded." },
];

export const MochaStory = () => (
  <section data-testid="mocha-story" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
      <div className="md:col-span-6">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
            03 / The Craft
          </p>
          <h2
            data-testid="mocha-story-headline"
            className="font-display text-4xl md:text-6xl tracking-tighter leading-[1.05] text-[#2C241E]"
          >
            One Shade Family. Zero Compromise.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[#2C241E]/70 max-w-xl">
            We spent longer choosing a brown than most brands spend designing a product. Mocha,
            taupe, beige — borrowed from good coffee and better interiors, never from a pharmacy.
          </p>
        </Reveal>
        <div className="mt-10 space-y-4">
          {SHADES.map((s, i) => (
            <Reveal key={s.name} delay={0.1 + i * 0.08}>
              <div data-testid={`shade-${s.name.toLowerCase()}`} className="flex items-center gap-5">
                <span
                  className="w-12 h-12 rounded-2xl border border-[#2C241E]/10 shrink-0"
                  style={{ backgroundColor: s.hex }}
                />
                <div>
                  <p className="font-display text-xl text-[#2C241E]">{s.name}</p>
                  <p className="text-sm text-[#2C241E]/55">{s.note}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.35}>
          <Link
            to="/craft"
            data-testid="craft-link"
            className="mt-10 inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
          >
            Explore the craft
            <ArrowRight size={16} strokeWidth={1.75} />
          </Link>
        </Reveal>
      </div>
      <Reveal className="md:col-span-6" delay={0.15}>
        <div className="rounded-2xl overflow-hidden aspect-[4/5]">
          <img
            src="https://images.unsplash.com/photo-1643313260651-9c335822ecde?q=80&w=1600&auto=format&fit=crop"
            alt="Macro close-up of LIGATEN compression knit"
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
